import moment from 'moment';
import countriesAndTimezones from 'countries-and-timezones';

const formatUtcToLocalDate = (utc, inputFormat, outputFormat = inputFormat, timezone, dst) => {
  let utcOffset = -300; // Default New York UTC Offset
  if (timezone) {
    utcOffset = dst
      ? countriesAndTimezones.getTimezone(timezone).dstOffset
      : countriesAndTimezones.getTimezone(timezone).utcOffset; 
  }
  return moment.utc(utc, inputFormat).utcOffset(utcOffset).format(outputFormat);
};

export default formatUtcToLocalDate;



// WEBPACK FOOTER //
// ./src/utils/formatUtcToLocalDate.js